import { render, staticRenderFns } from "./JobsReport.vue?vue&type=template&id=5b2f5f34&"
import script from "./JobsReport.vue?vue&type=script&lang=js&"
export * from "./JobsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports